module.exports = __webpack_public_path__ + "static/media/p3.b5690db2.jpg";